<!--
2023-06-02 ytw
-->
<template>
  <div class="pop-confirm">
    <div class="white-content" @click="toContinue" v-if="confirmBtn === 5"></div>
    <div class="panel">
      <div class="white-fonts" v-for="(item, index) in alertMsg" :key="index">
        <span>{{ item }}</span>
      </div>
      <div class="gray-fonts" v-if="rewardMsg&&rewardMsg.length>0"
           :style="toDoList&&toDoList.length>0&&(confirmBtn===5||confirmBtn===6||confirmBtn===7)?'margin: 4vw 0;':''">
        <div v-for="(item, index) in rewardMsg" :key="index">{{ item }}</div>
      </div>
      <div class="tasks" v-if="toDoList&&toDoList.length>0&&(confirmBtn===5||confirmBtn===6||confirmBtn===7)">
        <div class="task" v-for="(task,index) in toDoList" :key="index">
          {{ $t('lang.luckyWheel.taskName.' + task.TaskName) }}{{
            '(' + task.TaskValue + '/' + task.DoneTaskValue + ')'
          }}
        </div>
      </div>
      <div class="buttons" v-if="confirmBtn&&confirmBtn!==5">
        <div class="btn" @click="toContinue" v-if="confirmBtn===1||confirmBtn===2||confirmBtn===3">
          <span>{{ $t('lang.luckyWheel.continue') }}</span>
        </div>
        <div class="btn" @click="toDeposit" v-if="confirmBtn===1">
          <span>{{ $t('lang.luckyWheel.deposit') }}</span>
        </div>
        <div class="btn" @click="doingPlay" v-if="confirmBtn===3">
          <span>{{ $t('lang.luckyWheel.spin') }}</span>
        </div>
        <div class="btn" @click="play" v-if="confirmBtn===2||confirmBtn===4||confirmBtn===7">
          <span>{{$t('lang.luckyWheel.play')}}</span>
        </div>
        <div class="btn" @click="goClickFunc()" v-if="confirmBtn===6">
          <span>{{$t('lang.luckyWheel.executeBtn')}}</span>
        </div>
        <div class="btn" @click="toContinue" v-if="confirmBtn===4||confirmBtn===6||confirmBtn===7">
          <span>{{$t('lang.luckyWheel.cancel')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'wheelConfirm',
  props: [
    'closeConfirm',
    'closeAll',
    'confirmBtn',
    'giftItem',
    'doingPlay',
    'freeBetPlayTimes',
    'alertMsg',
    'rewardMsg',
    'toDoList',
    'getTimes',
    'contentClass',
    'doTasks'
  ],
  data () {
    return {
      noTimes: null,
      sorry: null,
      success: null,
      congratulation: null
    }
  },
  mounted () {
  },
  created () {
    let lang = this.$store.state.locale
    if (lang === 'EN') {
      this.sorry = this.sorryEn
      this.success = this.successEn
      this.noTimes = this.noTimesEn
    } else {
      this.sorry = this.sorryHi
      this.success = this.successHi
      this.noTimes = this.noTimesHi
    }
  },
  methods: {
    toContinue () {
      this.closeConfirm()
    },
    play () {
      this.closeAll()
    },
    goClickFunc () {
      if (this.toDoList && this.toDoList.length === 1) {
        let task = this.toDoList[0]
        let taskName = task.TaskName.toLowerCase()
        if (taskName.indexOf('upi_deposit_amount') > -1) {
          this.toUpi()
        }
        if (taskName.indexOf('deposit') > -1) {
          this.toDeposit()
        } else {
          this.closeAll()
        }
      } else {
        this.closeAll()
      }
    },
    toDeposit () {
      this.closeAll()
      if (this.confirmBtn === 1 && this.giftItem && this.giftItem.GiftType === 'discount') {
        this.$router.push({name: 'Deposit', query: {guid: this.giftItem.GiftUuid}}) // 告知充值页面使用充值赠券
      } else {
        this.$router.push('/Deposit')
      }
    },
    toUpi () {
      this.closeAll()
      this.$router.push({path: '/Deposit', query: {key: 'UpiGuide'}})
    },
    covertTaskName (item) {
      let key = item.TaskName
      return this.$t('lang.luckyWheel.taskName')[key]
    }
  }
}
</script>

<style lang="less" scoped>
.pop-confirm {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, .6);
  z-index: 990;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;

  .white-content {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgb(0, 0, 0 0.7);
  }

  .panel {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 82.222vw;
    height: max-content;
    background: #181818;
    padding: 6.6667vw 6.25vw;
    border-radius: 2.222vw;
  }

  .white-fonts {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    display: flex;
    width: 85%;
    text-align: center;

    span {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      font-family: Inter;
      font-size: 5.833vw;
      font-weight: 700;
      text-align: center;
      color: #D9D9D9;
    }
  }

  .gray-fonts {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: max-content;
    text-align: center;
    margin: 9vw 0;

    div {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      font-family: Inter;
      font-size: 4.166vw;
      line-height: 4.166vw;
      font-weight: 500;
      text-align: center;
      color: #818181;
      width: 100%;
    }
  }

  .tasks {
    margin: 6vw auto 2vw auto;
    width: 55.311vw;
    height: max-content;
    max-height: 75.355vw;
    overflow-x: hidden;
    overflow-y: auto;

    .task {
      margin: 2vw auto;
      width: 55.311vw;
      height: 7.922vw;
      line-height: 7.922vw;
      text-align: center;
      border-radius: 4.166vw;
      background: #2C2C2C;
      color: #a2a2a2;
      font-family: Inter;
      font-size: 3.194vw;
      font-weight: 400;
    }
  }

  .buttons {
    margin: 5vw auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 69.722vw;
    height: 8.889vw;

    .btn {
      width: 32.222vw;
      height: 8.889vw;
      line-height: 8.889vw;
      border-radius: 2.222vw;
      background: #F1DAB0;
      font-family: Inter;
      font-size: 3.8889vw;
      font-weight: 600;
      text-align: center;
      color: #000000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Wheel/confirm.vue